export class DummyProvider {    

    initialize = () => async () => {};

    login = (_language) => {};

    silentAuthentication = (_callback) => {};

    otcAuthentication = (_code, _userName) => {};

    passUserName = (_userName) => {};

    handleAuthentication = (_callback) => {};

    logout = () => {};

    getAccessToken = async () => {};

    getProfile = () => { return {}; };

    getTokenTimeToLive = () => {};

    isAuthenticated = () => false;

    isRegularAuthentication = (_) => false;
}